import { FC } from 'react';
import strings from '../../../../common/Translation/Translate';
import axiosInstance from '../../../../utils/axios';
import { URLS } from '../../../../utils/constants/urls';
import { createDropdownData } from '../../../../utils/validators/HelperFunctions';
import IdsMappingList, { IdsMappingListConfig } from '../shared/IdsMappingList';
import { optionLabel, optionValue } from '../shared/idsMappingTableCells';
import { AddEditVenueMappingsForm } from './AddEditVenueMappings/AddEditVenueMappingsForm';

const venueMappingConfig: IdsMappingListConfig = {
  kind: 'venue',
  title: 'Venue Mappings',
  subtitle: 'Map BBR venues to IDS venue names and codes.',
  addButtonText: 'Add Venue Mapping',
  addDrawerTitle: 'Add Venue Mapping',
  editDrawerTitle: 'Edit Venue Mapping',
  searchPlaceholder: 'Search by IDS name or code',
  entityLabel: 'Venue mappings',
  listApi: URLS.venueMappings,
  addApi: URLS.addVenueMapping,
  getById: URLS.getVenueMappingById,
  saveApi: URLS.editVenueMapping,
  deleteApi: URLS.deleteVenueMapping,
  importApi: URLS.importVenueMappings,
  downloadImportTemplate: URLS.downloadVenueMappingsTemplate,
  bbrHeader: 'BBR Venue',
  idsHeader: 'IDS Venue',
  idsSortField: 'mainVenueName',
  getBbrLabel: row => optionLabel(row.venue) || '—',
  getIdsName: row => row.venueName,
  getIdsCode: row => row.venueCode,
  formModel: options => AddEditVenueMappingsForm(strings, options),
  emptyFormValues: { venue: '', venueName: '', venueCode: '' },
  loadDropdownOptions: async () => {
    const { data, status } = await axiosInstance.get(URLS.venues);
    if (status === 200 && data?.length > 0) {
      return createDropdownData(data, ['id', 'name']);
    }
    return [];
  },
  mapResponseToForm: data => ({
    venue: data.venue || '',
    venueName: data.venueName || '',
    venueCode: data.venueCode || '',
  }),
  mapFormToPayload: body => ({
    venueId: optionValue(body.venue),
    venueName: body.venueName,
    venueCode: body.venueCode,
  }),
  getDeleteEntityName: values => optionLabel(values.venue) || String(values.venueName || ''),
};

const VenueMappingsList: FC = () => <IdsMappingList config={venueMappingConfig} />;

export default VenueMappingsList;
